import React from "react";
import { Helmet } from "react-helmet";

interface HeadProps {
  title: string;
  url: string;
  description: string;
  image?: string;
}

const Head = (props: HeadProps) => {
  return (
    <Helmet>
      <title>{`${props.title} - Ubiquiti`}</title>
      <link rel="canonical" href={props.url} />
      <meta name="description" content={props.description} />
      <meta property="og:url" content={props.url} />
      <meta property="og:title" content={`${props.title} - Ubiquiti`} />
      <meta property="og:description" content={props.description} />
      {props.image ? (
        <meta property="og:image" content={props.image} />
      ) : (
        <meta
          property="og:image"
          content={`https://www.ui.com/microsite/og-image.png`}
        />
      )}
    </Helmet>
  );
};

export default Head;
